import { render, staticRenderFns } from "./LEAGUEINVITE.vue?vue&type=template&id=2d662eae"
import script from "./LEAGUEINVITE.vue?vue&type=script&lang=js"
export * from "./LEAGUEINVITE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports